<template>
    <v-fade-transition hide-on-leave>
        <component v-bind:is="layout"></component>
    </v-fade-transition>
</template>

<script>
import AppLayout from '@/layouts/AppLayout'
import SimpleLayout from '@/layouts/SimpleLayout'

export default {
    components: {
        'app-layout': AppLayout,
        'simple-layout': SimpleLayout,
    },

    async beforeCreate() {
        let isAuthenticated = this.$store.getters['auth/token']
        if (!isAuthenticated) {
            this.$store.dispatch('app/setIsLoaded', true)
            return
        }

        this.$store.dispatch('app/setIsLoaded', false)

        // Pega informações do revendedor
        await this.$store.dispatch('reseller/getReseller').catch(e => {
            console.log(e)
        })

        this.$store.dispatch('app/setIsLoaded', true)
    },

    computed: {
        layout() {
            return this.$store.getters['layout/layout']
        },
    },
}
</script>
